import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useBlogContext } from '../../../context/BlogContext';
import './BlogList.css';

export const BlogList: React.FC = () => {
    const { blogs } = useBlogContext();
    const navigate = useNavigate();

    const published = blogs.filter(b => !b.is_draft);

    const goTo = (title: string) => {
        const slug = title.toLowerCase().replace(/\s+/g, '-');
        navigate(`/blog/${encodeURIComponent(slug)}`);
    };

    return (
        <div className="blog-list-page">
            <Link to="/" className="blog-back-link">
                <span>&larr;</span>
                <img src="/moving_butterfly.gif" alt="Back to home" className="blog-back-gif" />
            </Link>
            <div className="blog-list-container">
                <h1 className="blog-list-title">Writing</h1>
                <p className="blog-list-subtitle">{published.length} post{published.length !== 1 ? 's' : ''}</p>
                <ul className="blog-list-items">
                    {published.map(blog => (
                        <li key={blog.id} className="blog-list-item">
                            <button className="blog-item-link" onClick={() => goTo(blog.title)}>
                                {blog.title}
                            </button>
                            <p className="blog-item-meta">
                                {blog.author || 'Unknown'}
                                {blog.published_at
                                    ? ` — ${new Date(blog.published_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`
                                    : ''}
                            </p>
                            {blog.summary && (
                                <p className="blog-item-summary">{blog.summary}</p>
                            )}
                        </li>
                    ))}
                    {published.length === 0 && (
                        <li className="blog-list-item">
                            <span style={{ color: '#888' }}>No posts yet.</span>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};
